import { limit, orderBy } from "firebase/firestore";
import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../../api/firebase/references";

export interface NarIngestionLog {
  id: string;
  created_at_time: Date;
  document_type: string;
  month: number;
  output_file_name: string;
  payer_type: string;
  processing_time_seconds: number;
  records_inserted: number;
  records_processed: number;
  source_file: string;
  status: string;
  sub_type: string;
  year: number;
  processed_csv_path?: string;
  is_rejected?: boolean;
}

export const useFetchGridInfo = (limitCount: number = 10) => {
  const [data, setData] = useState<NarIngestionLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const unsubscribe =
      FirestoreService.listenToQueryCollection<NarIngestionLog>(
        FirestoreCollectionReference.narIngestionLogs(),
        (documents) => {
          setData(documents);
          setLoading(false);
        },
        (error) => {
          console.error("Error listening to NAR ingestion logs:", error);
          setLoading(false);
        },
        orderBy("created_at_time", "desc"),
        limit(limitCount),
      );

    return () => {
      unsubscribe();
    };
  }, [limitCount]);

  return { data, loading };
};
